var exports = {
  "Gd": "responsiveContainer__4uT3Lc",
  "kL": "container__nfBEX7",
  "r0": "collapsible__S9ZM8J",
  "b": "collapsibleBody__ZvpKa7",
  "yZ": "collapsed__mKLmXK",
  "_X": "collapsibleBodyNoAnimation___62JQU",
  "Dd": "collapsibleBodyInner__AVSY3W",
};

module.exports = exports;
